var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-dock w-100 d-flex flex-column flex-xl-row"},[_c('div',{staticClass:"col"},[_vm._t("leftCol")],2),(_vm.hasRightCol())?_c('div',{staticClass:"col"},[_vm._t("rightCol")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }